import fetch from "auth/FetchInterceptor";

const authPermissionService = {};

authPermissionService.get = function () {
	return fetch({
		url: "/v1/rest/auth-permission-list",
		method: "get",
	});
};

export default authPermissionService;
